import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle, AlertCircle } from 'lucide-react';
import { API_URL, handleApiError } from '../lib/api';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setStatus('error');
        setMessage('No verification token provided.');
        return;
      }
      try {
        const res = await fetch(`${API_URL}/auth/verify-email?token=${encodeURIComponent(token)}`, {
          credentials: 'include',
        });
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw { status: res.status, data };
        }
        setStatus('success');
        setMessage('Email verified successfully! You may now log in.');
      } catch (err) {
        console.error('Email verification failed:', err);
        setStatus('error');
        setMessage(handleApiError(err));
      }
    };
    verify();
  }, [token]);

  const renderContent = () => {
    if (status === 'loading') {
      return <span className="text-gray-300">Verifying...</span>;
    }
    if (status === 'success') {
      return (
        <div className="flex flex-col items-center space-y-4">
          <CheckCircle className="w-12 h-12 text-green-400" />
          <span className="text-green-400 text-center">{message}</span>
        </div>
      );
    }
    return (
      <div className="flex flex-col items-center space-y-4">
        <AlertCircle className="w-12 h-12 text-red-400" />
        <span className="text-red-400 text-center">{message}</span>
      </div>
    );
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-white">
      {renderContent()}
    </div>
  );
};

export default VerifyEmail;
